import { useCallback } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import { PATHS } from 'src/routes/paths';

export const useHandleNavigation = () => {
    const location = useLocation();
    const navigate = useNavigate();

    return useCallback(() => {
        navigate(PATHS.POOL_PERSONALISED, { state: { referrer: location.pathname } });
    }, [navigate, location.pathname]);
};
